import { pricingProceduresSlice } from "./pricingProceduresSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = pricingProceduresSlice;
const moduleUrl = '/api/pricing/pricingProcedures'

export const setValidationErrors = actions.setValidationErrors;

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (values: any, id: string | null) => {
  const payload = {
    description: values.description,
    isCountrySpecific: values.isCountrySpecific === "true",

    createConditionTypes: (values.conditions || [])
        .filter((c: any) => !c.fixed)
        .map((conditionType: any, index: number) => ({
          conditionTypeId: conditionType.id,
          order: index,
        })
    ),

    createCountries:
      values.isCountrySpecific === "true"
        ? (values.countryId || []).map((c: any) => ({
            countryId: c.id,
          }))
        : [],
  };

  return defaultActions.saveItem(
    moduleUrl,
    actions,
    payload,
    id
  );
};

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
